import { IProduct } from './models/product.interface';

export interface TopProductsResp {
  // tslint:disable-next-line:no-any
  links: any;
  products: IProduct[];
  count: number;
  totalCount: number;
}
